<template>
  <div id="customer_credit_request">
    <div :class="`loader${loaderClass}`" v-show="loading">
    </div>
    <div class = "invoice-view-table" id="customer-credit-request">
        <table aria-describedby="table" class = "table table-sm table-stripped">
          <thead>
            <tr class="table-primary">
              <th>Customer</th>
              <th>Agreement Number</th>
              <th>Request / Approved By</th>
              <th>Type</th>
              <th>Status</th>
              <th>Req. Time</th>
              <th>Actions</th>
            </tr>
          </thead>
            <tbody>
            <template v-if="CreditRequestArr && CreditRequestArr.length > 0">
              <template v-for="(rc, rcindex) in CreditRequestArr">
                <tr v-bind:key="rcindex" v-if="rc.type_case != 'Depreciation' && rc.send_to == userId && rc.type_case!='Credit Override Approved' && rc.type_case!='Credit Override Denied' && rc.type_case!='Rate Approval Approved' && rc.type_case!='Rate Approval Denied'">
                  <td>
                      <router-link class="color-blue"  v-bind:to="{name:'CustomerView',params:{id:rc.cust_id}}" target="_blank">{{ rc.customer_code }} </router-link>
                  </td>
                  <td>
                    <span v-fp-html="rc.agreement_no"></span>
                      <!-- <router-link class="color-blue"  v-bind:to="{name:'RentalAgreementView',params:{id:rc.agreement_id}}" target="_blank">{{ rc.agreement_no }} </router-link> -->
                  </td>
                  <td>
                      {{ rc.updated_by }}
                  </td>
                  <td>
                      {{ rc.type_case }}
                  </td>
                  <td>
                      {{ rc.credit_status }}
                  </td>
                  <td>
                      {{ rc.created_at }}
                  </td>
                  <td>

                      <button v-if="rc.credit_status == 'Sent' || (rc.credit_status == 'Denied' && rc.type != 'rate_approval')" id="approveBtn" @click="sendForApproval('approved',rc.id,rc.type)"  class="btn btn-primary">Approve</button>
                      <!-- <span class="border-right ml-3 mr-3" ></span> -->
                      <button v-if="rc.credit_status == 'Sent' || (rc.credit_status == 'Approved' && rc.type != 'rate_approval')" id="denyBtn" @click="sendForApproval('denied',rc.id,rc.type)" class="btn btn-danger">Deny</button>

                  </td>
                </tr>
              </template>
            </template>
            <template v-else>
                <tr>
                    <td class="no-data-found" colspan="12">{{"No Credit Request Found!"}}</td>
                </tr>
            </template>
          </tbody>
        </table>
      </div>
  </div>
</template>
<script>
import Vue from "vue";

export default {
  name:"customerCreditRequest",
  props: {
      customerId:{
        type: Number,
        required: false,
        default:undefined
      },
      agreementId:{
        type: Number,
        required: false,
        default:undefined
      },
      from:{
        type: String,
        required: false,
        default:undefined
      },
  },
  mounted: function() {

      var self = this;
      self.getCustomerCreditRequest();

      var userObj = JSON.parse(localStorage.getItem("user_obj"));
      if (userObj != null) {
        self.userId = userObj.id;
      }

  },
  data: () => ({
    loading:false,
    cantAccessPage: "",
    permissions: [],
    CreditRequestArr:[],
    userId:0,
  }),
  created: function() {

  },

  methods:{

    getCustomerCreditRequest(){
      console.log("checke the flow");
      var self = this;
      self.loading = true;
      var customer = '';
      if(this.customerId != undefined){
       customer = this.customerId;
      }

        $.ajax({
            url: process.env.ROOT_API + "/fetch-customer-credit-request",
            type: "POST",
            data: {
                customer_id: customer,
                from:self.from,
                agreementId:self.agreementId
            },
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
              self.loading = false;
              console.log(data.content.row);
              self.CreditRequestArr = data.content.row;
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR, true, 'customer-credit-request');
            }
        });


    },
    sendForApproval:function(flag,reqId,type){

        var self = this;

        if (self.from != undefined && self.from == 'agreement' && type == 'rate_approval'){
          var fl = '';
          if (flag == 'approved'){
            fl = 'approve';
          }else{
            fl = 'reject';
          }
          self.$parent.approveRates(fl);
          return;
        }
        self.loading = true;

        $.ajax({
            url: process.env.ROOT_API + "/user/send-notification",
            type: "POST",
            headers: this.ajxHeaders,
            dataType: "json",
            data:{
                status: flag,
                reqId:reqId
            },
            success: function (data) {
                self.loading = false;
                if ( data.status == "success") {
                    self.exDate = '';
                    if (type == 'security_deposit'){
                        self.$swal('','Security Deposit Refund request has been updated successfully.','success');
                    }else{
                        self.$swal('','Credit Override request has been updated successfully.','success');
                    }
                    self.getCustomerCreditRequest();

                } else if ( data.status == "error" ) {
                    self.$swal('',data.message,'error');
                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                if (jqXHR.status == 0) {
                    self.errorMsg = "Remote server cannot be reached";
                } else {
                    //redirect to login page if user not authenticated
                    if (jqXHR.status == 401) {
                        //clear previous data
                        localStorage.removeItem("user_obj");
                        localStorage.removeItem("tkn");
                        self.$router.push("/");
                    }
                    self.error = jqXHR.responseJSON.message;
                }
            }
        });
    },


  },


};
</script>



// WEBPACK FOOTER //
// src/components/CustomerCreditRequest.vue